<template>
  <div>
    <div class="justify-content-center">
      <div class="position-relative cursor-pointer d-inline-block" @click.prevent="modalTriggerOpenModal()">
        <email class="svg-24 svg-accent svg-email-icon"></email>
      </div>
      <modal v-show="modalTriggerValue" modalclass="no-footer" @close="modalTriggerCloseModal()" clickoutside="true">
        <div slot="header" class="d-flex justify-content-between full-width">
          <i class="close-icon" @click="modalTriggerCloseModal()"></i>
        </div>
        <div class="content" slot="body">
          <div class="email-faculty">
            Are you sure you want to re-send the faculty email to {{ faculty_email }}
            <div class="d-flex justify-content-center mt-3 mb-3">
              <button type="submit" @click="sendEmail()">Yes, Resend Faculty Email</button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import modal from './Modal.vue';
import email from './icons/email.vue';

export default {
  name: "EmailFaculty",
  props: ['actionurl','faculty_email'],
  components: {modal, email},
  data() {
    return {
      modalTriggerValue: false,
    }
  },
  methods : {
    modalTriggerOpenModal: function() {
      let app = this;
      app.modalTriggerValue = true;
    },
    modalTriggerCloseModal: function() {
      let app = this;
      app.modalTriggerValue = false;
    },
    sendEmail: function () {
      let app = this;
      window.axios(
          {
            method: 'post',
            url: app.actionurl,
          }).then(function(response) {
        let dataBack = response.data;
        app.$parent.$parent.$refs.flash_alert.activateFlashAlert(dataBack.message, 'success');
        app.modalTriggerValue = false;
      }).catch(function (err) {
        let errorMessage = 'Email not sent. 421 Server error';
        app.$parent.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    }
  }
}
</script>
<style lang="scss">
.bmpui-ui-watermark {
  display:none;
}
.bmpui-ui-recommendation-overlay {

}
</style>
